export default "__VITE_ASSET__DmDji$7J__"